import { useRef, useState, useEffect, cloneElement, isValidElement } from "react";

// HOVER HELP ON A BUTTON, AND A LONG PRESS ON A TABLET (his instruction, 2026-10-14).
//
// *"Add hover help on every button, and the same help on a tablet — hold the button down."*
//
// ONE WRAPPER, TWO HABITS. On a PC the bubble opens on hover after a short pause, the way a person
// expects; on a tablet there is no hover, so holding the button for half a second opens the same
// words — and a HOLD never fires the button, so reading the help can never book a part out.
//
//   <HelpTip text="Reads the numbers again — charged">
//     <Button …>Read the numbers again</Button>
//   </HelpTip>
//
// `title` is set as well, so even a browser with no JavaScript help still shows something.
export function HelpTip({ text, children, side = "top", testid, className = "" }) {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const held = useRef(false);

  useEffect(() => () => clearTimeout(timer.current), []);
  if (!text || !isValidElement(children)) return children || null;

  const show = (delay) => { clearTimeout(timer.current); timer.current = setTimeout(() => setOpen(true), delay); };
  const hide = () => { clearTimeout(timer.current); setOpen(false); };

  const kid = cloneElement(children, {
    title: text,
    onPointerDown: (e) => {
      held.current = false;
      if (e.pointerType !== "mouse") { clearTimeout(timer.current); timer.current = setTimeout(() => { held.current = true; setOpen(true); }, 500); }
      children.props.onPointerDown?.(e);
    },
    onPointerUp: (e) => {
      clearTimeout(timer.current);
      if (held.current) { e.preventDefault(); e.stopPropagation(); }   // a hold reads, it never presses
      children.props.onPointerUp?.(e);
    },
    onClick: (e) => {
      if (held.current) { held.current = false; e.preventDefault(); e.stopPropagation(); setTimeout(() => setOpen(false), 2500); return; }
      setOpen(false);
      children.props.onClick?.(e);
    },
  });

  return (
    <span className={`relative inline-flex ${className}`} onMouseEnter={() => show(350)} onMouseLeave={hide}
      onPointerCancel={hide}>
      {kid}
      {open && (
        <span data-testid={testid || "help-tip"} role="tooltip"
          className={`pointer-events-none absolute z-50 ${side === "bottom" ? "top-full mt-1.5" : "bottom-full mb-1.5"} left-1/2 -translate-x-1/2
            w-max max-w-[260px] rounded-lg bg-slate-900 px-2.5 py-1.5 text-[11px] leading-snug text-white shadow-lg`}>
          {text}
        </span>
      )}
    </span>
  );
}
